import {Button, ButtonGroup, Choice, closeDialog} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useState} from 'react';

import i18n from '@dms/i18n';
import {getOptionsFromVatRates, useVatRatesOptions} from '@dms/shared';

import {pushGtmEvent} from 'shared/web';

interface ChangeVatProps {
  dialogId: string;
  onAssign: (vatType: string) => void;
}

export function ChangeVat(props: ChangeVatProps) {
  const [vatType, setVatType] = useState<string | null>('S');

  const vatRates = useVatRatesOptions();

  const handleDiscard = () => {
    pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_change_vat_discard'});
    closeDialog(props.dialogId);
  };

  const handleAssign = () => {
    if (!vatType) {
      return;
    }
    pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_change_vat'});
    props.onAssign(vatType);
    closeDialog(props.dialogId);
  };

  return (
    <VStack spacing={4}>
      <Choice
        isRequired
        isNotClearable
        value={vatType}
        onChange={setVatType}
        options={getOptionsFromVatRates(vatRates)}
        label={i18n.t('entity.warehouse.labels.vat')}
        menuInPortal
      />
      <ButtonGroup align="right">
        <Button
          title={i18n.t('general.actions.discard')}
          variant="secondary"
          onClick={handleDiscard}
        />
        <Button
          isDisabled={!vatType}
          title={i18n.t('general.actions.assign')}
          variant="primary"
          onClick={handleAssign}
        />
      </ButtonGroup>
    </VStack>
  );
}
